import { SATURDAY, SUNDAY } from './constants';

export const isWeekday = (date: string | Date) => {
  const format = new Date(date);
  return format.getDay() !== SATURDAY && format.getDay() !== SUNDAY;
};
